import { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Navigation from "../../Components/Navigation/Navigation";
import logo from "../../assets/images/LogoNew.png";
import cart from "../../assets/images/Cart.svg";
import notification from "../../assets/images/Notification.svg";
import task from "../../assets/images/My Tasks.svg";
import hamburger from "../../assets/images/Menu.svg";
import logout from "../../assets/images/logout.svg";
import Myorder_Unsubmitted from "../../assets/images/DraftMyCart.svg";
import Delete from "../../assets/images/Delete.svg";
import ModalPopup from "../ModalPopup/ModalPopup";
import UserProfile from "../../Components/UserProfile";
import "./Header.scss";
import avatar from "../../assets/images/avatar.jpg";
import { PopupDialogbox, Tabs, Tooltip, EventHandler } from 'client/CommonComponents'
import MyAlertNew from "client/Components/OrderManagement/Home/MyAlert-New";
import MyNotificationNew from "client/Components/OrderManagement/Home/MyNotification-New";
import { AlertNotificationDispatch as myAlertNotificationDispatch} from "Store/AlertNotification/AlertNotificationDispatch";
import { CONSTANTS } from "client/utils/constants";
import orderDispatch from "Store/OrderManagement/Order/OrderDispatch";
import { Alert } from "client/CommonComponents";
import { useLocation } from "react-router-dom";
import NavigationAssetInventory from "client/Components/AssetInventory/Navigation";
import NavigationActiveAsset from "client/Components/ActiveAsset/Navigation"
import { ASSET_INVENTORY_CONSTANTS } from "../../utils/constants/assetInventory"
import infoIcon from '../../assets/images/Custom support White.svg'

interface IProps {
  heading?: any;
  showMenu?: boolean;
  userMenuList?: any;
  toggleDropdown?: any;
  BranchList?: any;
  userDetails?: any;
  handleClickBranch?: any;
  menu?: any;
  wrapperRef?: any;
  showBranchDrpdown?: any;
  handleClick?: any;
  ShowPopup?: any;
  handleLogout?: any;
  showUserProfilePopup?: any;
  hidePopup?: any;
  cartClick?: any;
  homeCostCenter?:any;
  showAlertNotificationPopup?:any,
  handleClickAlertNotification?: any,
  nav?: string;
  setAlertNotificationPopup?: any;
  handleClickMyCart?:any;
  showMyCartPopup?:any;
  myCartValues?: any;
  navigateToPage?: any;
  deleteCartDraftOrder?:any;
  deletePopup?: any;
  successAlert?: any;
  dismissSuccessAlert?: any;
  cartOrderDelete?: any;
  showZohoAccessPopup?:any;
  handleInfoSection?:any;
  hideZohoAccessPopup?:any;
  InfoSection?:any;  
  onDraftDeleteClick?: any;
  Popupcontent?: any;
  hideConfirmationDialog?: any;
  isDeleteCartClicked?: any;
  defaultLocationTemp?: any;
  env?: any;
}
const Header = ({
  showMenu = false,
  toggleDropdown,
  BranchList = [],
  userDetails = [],
  handleClickBranch,
  menu,
  wrapperRef,
  showBranchDrpdown,
  handleClick,
  ShowPopup,
  handleLogout,
  showUserProfilePopup,
  hidePopup,
  homeCostCenter,
  showAlertNotificationPopup,
  handleClickAlertNotification,
  setAlertNotificationPopup,
  handleClickMyCart,
  showMyCartPopup,
  myCartValues,
  navigateToPage,
  deletePopup,
  dismissSuccessAlert,
  cartOrderDelete,  
  showZohoAccessPopup,
  handleInfoSection,
  hideZohoAccessPopup,
  InfoSection,
  onDraftDeleteClick,
  Popupcontent,
  hideConfirmationDialog,
  isDeleteCartClicked,
  defaultLocationTemp,
  env
}: IProps) => {
  const treeData: any = [
    {
      title: "Division",
      value: "Division",
      children: {
        title: "SuperRegion",
        value: "SuperRegion",
        children: {
          title: "Region",
          value: "Region",
          children: {
            title: "Market",
            value: "Market",
            children: {
              title: "BVD Orane Country",
              value: "BVD Orange Country",
            },
          },
        },
      },
    },
  ];
  const showSupportIcon = useMemo(() => userDetails?.isZohoEnabled, [userDetails])
  const dispatch = useDispatch();
  const [getBranches,setGetBranches] = useState<any>([]);
  const [duplicateBranch,setDuplicateBranch] = useState<any>([]);
  const [branchValues,setBranchValues] = useState('');

  const dispatchGetMyAlertNotificationDetails = myAlertNotificationDispatch.dispatchGetMyAlertNotificationDetails(dispatch);
  const dispatchGetCartCount = orderDispatch.dispatchGetCartCount(dispatch);
  const dispatchSetIsAlertNotificationApiCalled = myAlertNotificationDispatch.dispatchSetIsAlertNotificationApiCalled(dispatch);
  const { myAlertDetails,myAlertDetailsNew, cartCount, cartOrders }: any = useSelector(
    (state: any) => ({
      myAlertDetails:state.AlertAndNotificationsReducer.myAlertNotificationDetails,
      cartCount: state.OrderReducer.cartCount
    })
  );

  const activemenu = useSelector((state: any) => state.nav.nav)

  useEffect(() => {
    if (userDetails?.userId) {
      if(activemenu === "Home")
      { 
        dispatchGetMyAlertNotificationDetails(userDetails?.userId)
        dispatchSetIsAlertNotificationApiCalled(true);
        dispatchGetCartCount(userDetails?.emailId)
      }
    }
  }, [userDetails?.userId])

  const { getUserProfileBlobUrl } = useSelector((state: any) => ({
    getUserProfileBlobUrl:
      state.UserProfile.getUserDetails.profileBlobUrl ?? "",
  }));
  
  useEffect(()=>  {
    const tmpBranches: Array<any> = [];
    if (BranchList?.length) {
      BranchList.forEach((x: any) => {
        tmpBranches.push({
          name: x.branchName,
          companyName: x.companyName,
          branchId: x.branchNo,
          branchNumber: x.costCenter,
        });
      });
    }
    setGetBranches(tmpBranches);
    setDuplicateBranch(tmpBranches);
  },[BranchList])

  const onBranchSearch = (e:any) => {
    let val = e.target.value;
    setBranchValues(val)
    if(val.length > 0) {
      let filterBranch = duplicateBranch.filter((item:any)=> {
        return item?.name?.toLowerCase()?.includes(val.toLowerCase()) || item?.branchNumber?.toLowerCase()?.includes(val.toLowerCase()) || item?.companyName?.toLowerCase()?.includes(val.toLowerCase())});
      setGetBranches(filterBranch)
    }
    else {
      setGetBranches(duplicateBranch);
    }
  }

  const closeClick = (e:any) => {
    e.stopPropagation();
    setBranchValues('');
    setGetBranches(duplicateBranch);

  }

  const commentsTooltipProps: any = {
    onRenderContent: () => {   
      return <div>{userDetails?.roles?.reduce((acc: any[], x: any) => {
        if (x?.applicationName === CONSTANTS?.ORDER_MANAGEMENT) {
          return acc.concat(x?.roleDisplayName)
        }
        return acc
      }, [])?.join(", ")}
      </div>
    }
  }
  const assetInventoryRoleProps: any = {
    onRenderContent: () => {   
      return <div>{userDetails?.roles?.reduce((acc: any[], x: any) => {
        if (x?.applicationName === CONSTANTS?.ASSET_AUDIT_INVENTORY_MANAGEMENT) {
          return acc.concat(x?.roleDisplayName)
        }
        return acc
      }, [])?.join(", ")}
      </div>
    }
  }
  const alertandNoti_TooltipProps: any = {
    onRenderContent: () => {   
        return <span>{"Alerts & Notification"}
        </span>
    }
  }

  const iconItems = [
    {
      headerText:<span>Alerts ({myAlertDetails?.alertCount})</span>,
      content:<MyAlertNew setAlertNotificationPopup = {setAlertNotificationPopup}/>
    },
    {
      headerText: <span>Notification ({myAlertDetails?.notificationCount})</span>,
      content:<MyNotificationNew setAlertNotificationPopup = {setAlertNotificationPopup}/>
    }
  ]

  const branchIemProps = (item: any) => {
    const content = (
      <div>
        <p>{item.branchNumber} - {item.name}</p>
        <span>{item.companyName}</span>
      </div>
    );

    return ({
      onRenderContent: () => {   
        return content;
      }
    })
  }

  const path = useLocation();
  const pathName = path?.pathname?.split("/")[1];

  return (
    <>
      <div className="newClass">
        <div className="header-wrapper clearfix">
          <div className="headerlogo-section">
            <img src={logo} alt="logo" />
            <p className="headText">LEADR - {env}</p>
          </div>      
          <div className="userprofile-section">
          <div className="border-mobile"></div>
            {pathName?.toLowerCase() !== ASSET_INVENTORY_CONSTANTS.ASSET_INVENTORY_PATHNAME && 
              <EventHandler onEvent={handleClickBranch} data-attribute="index_Default_EventHandler_10">
                <div
                  className="branch-drpdown"
                  ref={wrapperRef}
                >
                  <p className="branch-name">Default Location</p>
                  <p className="branch-hierarchy">{defaultLocationTemp.branchNumber} - {defaultLocationTemp.name}</p>
                  <i className="arrow-down"></i>
                  {showBranchDrpdown ? (
                    <>
                      <div className="branch-dropdown">
                        <div className="searchBlock">
                          <input type={'text'} ref={input => input && input.focus()}  onChange={onBranchSearch} value={branchValues} id='search-control'  className='search-control' data-attribute="index_Default_Input" />
                          {branchValues ? <span className="fa fa-close closeIcon" onClick={closeClick}></span> : null}
                        </div>
                        {
                          getBranches?.length ?
                          <ul className="usernavname-dropdown">
                          {getBranches?.map((item: any, _index: any) => {
                            return (
                              <li>
                                <Tooltip 
                                  tooltipProps={{...branchIemProps(item)}}
                                 data-attribute="index_Default_Tooltip_2">
                                  <EventHandler onEvent={() => handleClick(item)} data-attribute={`index_${(item?.branchNumber || item?.name || _index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                    <div
                                      className={`branch-card ${homeCostCenter === item.name ? 'defaultBadge' :
                                        defaultLocationTemp.name === item.name
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <div className="pull-left">
                                        <p className="branchNumber">{item.branchNumber} - {item.name}</p>
                                        <span>{item.companyName}</span>
                                      </div>
                                      <div className="pull-right branch-section">
                                        <span className="branch-image"></span>
                                      </div>
                                    </div>
                                  </EventHandler>
                                </Tooltip>
                              </li>
                            );
                          })}
                        </ul> : <p className="text-center noDataAvailable">No Record Found</p>
                        }
                      </div>
                    </>
                  ): null}
                </div>
              </EventHandler>
            }
            <div className="task-section hide">
              <EventHandler onEvent={(e: any) => e.preventDefault()} data-attribute="index_Default_EventHandler_3_2">
                <a href="/">
                  <img src={task} alt="task" title="Task" />
                </a>
              </EventHandler>
            </div>
            <div className="logout-section">
              <EventHandler onEvent={(e: any) => handleLogout(e)} data-attribute="index_Default_EventHandler_4_2">
                <a href="/">
                  <img src={logout} alt="Logout" title="Logout" />
                </a>
              </EventHandler>
            </div>
            <div className="notification-block hide">
              <EventHandler onEvent={(e: any) => e.preventDefault()} data-attribute="index_Default_EventHandler_5_2">
                <a
                  href="/"
                  id="trigger"
                  className="bellIcn"
                  title="Notification"
                >
                  <img src={notification} alt="notification" title ="Alerts & Notification" />
                </a>
              </EventHandler>
            </div>
            { showSupportIcon ? (
              <EventHandler onEvent={(e: any) => handleInfoSection(e)} data-attribute="index_Default_EventHandler_6_2">
                <div className="info-section">
                  <img src={infoIcon} alt="Support" title="Support" />
                </div>
              </EventHandler>
            ): null }          
            {pathName?.toLowerCase() !== ASSET_INVENTORY_CONSTANTS.ASSET_INVENTORY_PATHNAME &&
              <div className="alert-notification-section">
                <Tooltip tooltipProps={alertandNoti_TooltipProps} data-attribute="index_Default_Tooltip_2_2">
                  <EventHandler onEvent={handleClickAlertNotification} data-attribute="index_Default_EventHandler_7_2">
                    <div                     
                      className="alert-notification"
                      ref={wrapperRef}
                    >
                      <i className="fa fa-envelope-o"></i>
                      {myAlertDetails?.alertCount + myAlertDetails?.notificationCount > 0 ? (
                        <span className="notify-badge notification-badge">
                          {myAlertDetails?.alertCount + myAlertDetails?.notificationCount}
                        </span>
                      ) : null} 
                      {showAlertNotificationPopup ? (
                        <div className="alert-notification-container">
                          <Tabs tabItems={iconItems} linkFormat='links' className='userprofile-tab'  data-attribute="index_Default_Tabs" />
                        </div>
                      ) : null}
                    </div>
                  </EventHandler>
                </Tooltip>
              </div>
            }
            {pathName?.toLowerCase() !== ASSET_INVENTORY_CONSTANTS.ASSET_INVENTORY_PATHNAME &&
              <div className="mycart-popup-block">
                <EventHandler onEvent={handleClickMyCart} data-attribute="index_Default_EventHandler_8_2">
                  <div
                    className="cartsection-block"                   
                    ref={wrapperRef}
                  >
                    <img src={cart} alt="settings" title="Cart" />
                    <span className="notify-badge">{cartCount}</span>
                    {showMyCartPopup ? 
                      <div className="mycart-container">
                        <div className="my-cart">
                          { myCartValues?.length > 0 ? myCartValues?.map((item: any, _index: any) => {
                            return (
                              <div className="cart-block">
                                <div className="icon-section">
                                  <img src={Myorder_Unsubmitted} alt='Draft Icon' title='Draft Icon'/>
                                </div>
                                <div className="request-type">
                                  <p><b>{item?.requestType}</b></p>
                                  <EventHandler onEvent={(e: any) => navigateToPage(e,item?.requestType,item?.orderId, item?.isBulkOrder)} data-attribute={`index_${(item?.requestType || item?.orderId || _index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Draft_EventHandler`}>
                                    <a href='/' title='Draft Link'>Draft</a>
                                  </EventHandler>
                                </div>
                                <div className="date-section">
                                  {item?.savedDate}
                                  <EventHandler onEvent={(e: any) => onDraftDeleteClick(e,item?.orderId)} data-attribute={`index_${(item?.orderId || _index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Delete_EventHandler`}>
                                    <div
                                      className="edit-delete-section"                                   
                                    >
                                      <img
                                        src={Delete}
                                        alt=""
                                        className="delete-icon fa-pencil pull-right"
                                      />
                                    </div>
                                  </EventHandler>
                                </div>
                              </div>
                            )
                          }) : <div className="no-record-data me-0">No Record Available</div>}
                        </div>
                        {deletePopup && (
                          <PopupDialogbox
                            hideDialog={!Popupcontent.isDialogVisible}
                            onDismiss={hideConfirmationDialog}
                            Popupcontent={Popupcontent}
                            popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                            popupPrimarybtnOnclick={(
                              item: any,
                              actionby: string,
                              value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
                                actionby,
                                value)}
                           data-attribute="index_Default_PopupDilalogBox" />
                        )}
                      </div> : ""
                    }
                  </div>
                </EventHandler>
              </div>
            }
            <div className="user-name user-menu">
              <div className="user-detail">
                <div>{userDetails?.userName || ""}</div>                
                <span>
                  {pathName?.toLowerCase() === ASSET_INVENTORY_CONSTANTS.ASSET_INVENTORY_PATHNAME ?
                    <Tooltip tooltipProps={assetInventoryRoleProps} data-attribute="index_Default_Tooltip_3">
                      <span>{userDetails?.roles?.reduce((acc: any[], x: any) => {
                        if (x?.applicationName === CONSTANTS?.ASSET_AUDIT_INVENTORY_MANAGEMENT) {
                          return acc.concat(x?.roleDisplayName)
                        }
                        return acc
                      }, [])?.join(", ")}</span>
                    </Tooltip> :
                    <Tooltip tooltipProps={commentsTooltipProps} data-attribute="index_Default_Tooltip_4">
                      <span>{userDetails?.roles?.reduce((acc: any[], x: any) => {
                        if (x?.applicationName === CONSTANTS?.ORDER_MANAGEMENT) {
                          return acc.concat(x?.roleDisplayName)
                        }
                        return acc
                      }, [])?.join(", ")}</span>
                    </Tooltip>
                  }  
                </span>
              </div>
              <EventHandler onEvent={toggleDropdown} data-attribute="index_Default_EventHandler_11">
                <div className="profile-image-block">
                  <img
                    src={getUserProfileBlobUrl}
                    onError={(e: any) => {
                      e.target.onerror = null
                      e.target.src = avatar
                    }}
                    alt="user"
                    title="My Profile"
                  />
                  <span
                    aria-hidden="true"
                    className="fa fa-caret-down down-arrow"
                  />
                </div>
              </EventHandler>
              {showMenu ? (
                <div className="custom-dropdown-menu">
                  <ul className="usernavname-dropdown pb-0">
                    <div className="userprofile-detail">
                      <div>{userDetails?.userName || ""}</div>
                      <span>{userDetails?.role}</span>
                    </div>
                    <EventHandler onEvent={(e:any) => { toggleDropdown(); ShowPopup(e); }} data-attribute="index_Default_EventHandler_12">
                      <li>
                        <a href="/">
                          <span className="user-dropdown-icon profile"></span>
                          <span className="ps-4">Profile</span>
                        </a>
                      </li>
                    </EventHandler>
                    <EventHandler onEvent={(e: any) => handleLogout(e)} data-attribute="index_Default_EventHandler_13">
                      <li>
                        <a href="/" onClick={(e: any) => e.preventDefault()}>
                          <span className="user-dropdown-icon logout"></span>
                          <span className="ps-4">Logout</span>
                        </a>
                      </li>
                    </EventHandler>
                  </ul>
                </div>
              ): null}
            </div>
            <EventHandler onEvent={ShowPopup} data-attribute="index_Default_EventHandler_14">
              <div className="hamburger-section">
                <a href="/" onClick={(e: any) => e.preventDefault()}>
                  <img src={hamburger} alt="menu" />
                </a>
              </div>
            </EventHandler>
          </div>
        </div>
        {
          menu && pathName?.toLowerCase() === ASSET_INVENTORY_CONSTANTS.ASSET_INVENTORY_PATHNAME ? <NavigationAssetInventory/>
          : menu && pathName?.toLowerCase() === "activeasset" ? <NavigationActiveAsset/> : <Navigation/>
        }
      </div>
      <div className="myprofile-userprofile">
        {showUserProfilePopup ? (
          <ModalPopup
            ShowModalPopupFooter={false}
            ModalPopupTitle="USER PROFILE"
            ModalPopupType="medium-large"
            closeModalPopup={hidePopup}
            ModalPopupName='userprofile-popup'
           data-attribute="index_Default_ModalPopup">
            <UserProfile closeModalPopup={hidePopup} />
          </ModalPopup>
        ) : null}
      </div>
      <Alert
        className="alert-message successAlert draft-delete"
        showAlert={cartOrderDelete && isDeleteCartClicked}
        dismissAlert={dismissSuccessAlert}
        type="success"
        text="Draft deleted successfully"
       data-attribute="index_Default_Alerts" />
      {showZohoAccessPopup ? (
          <ModalPopup
            ShowModalPopupFooter={false}
            ModalPopupTitle="SUPPORT"
            ModalPopupType="medium"
            closeModalPopup={hideZohoAccessPopup}
            ModalPopupName='zohosupport-popup'
           data-attribute="index_Default_ModalPopup_2">
            <div className="info-block">
            {
              InfoSection?.map((item:any, index:any)=>{                
                return(
                  <div className="info-section-tile">
                    <a href={item?.url} target="_blank">
                    <img src={item?.icon} alt={item?.text} title={item?.text}/>                    
                    </a>
                    <p>{item?.text}</p>
                  </div>
                )
              })
            } 
            </div>           
          </ModalPopup>
        ) : null}
    </>
  );
};

export default Header;
